import cn from "clsx";
import { Link } from "../link/link";
import { HandlePageClick, Page } from "./pagination";

export interface PaginationNumberProps {
  pages: Array<Page>;
  handlePageClick: HandlePageClick;
}

export function PaginationNumber({
  pages,
  handlePageClick,
}: PaginationNumberProps) {
  return (
    <>
      {pages.map((page: Page, i: number) => (
        <li
          key={i}
          className={cn(
            "hbs-pagination__page-item",
            page.isCurrent && "hbs-pagination__page-item--active",
          )}
          aria-current={page.isCurrent ? "page" : undefined}
          aria-label={
            page.isCurrent ? `Current page, page ${page.number}` : undefined
          }
        >
          {page.isCurrent ? (
            <span className="hbs-pagination__page-number">{page.number}</span>
          ) : (
            <Link
              className="hbs-pagination__page-number"
              href={page.link}
              aria-label={`Page ${page.number}`}
              onClick={(e) => handlePageClick(e, page)}
            >
              {page.number}
            </Link>
          )}
        </li>
      ))}
    </>
  );
}
